/** Segments under `/projects/:projectId/<tab>` used by ProjectDetail tab navigation. */
export const PROJECT_DETAIL_TAB_IDS = [
  'overview',
  'site-map',
  'test-runs',
  'playwright-tests',
  'security',
  'explorations',
  'bugs',
] as const

export type ProjectDetailTabId = (typeof PROJECT_DETAIL_TAB_IDS)[number]

export function isProjectDetailTab(tab: string): tab is ProjectDetailTabId {
  return (PROJECT_DETAIL_TAB_IDS as readonly string[]).includes(tab)
}
